import React from "react";
import "./assets/css/checkbox.css";

const Checkbox = (props: any) => {
  return (
    <div className="form-group">
        <div className="switch">
        <label className="switch__container">
            <input
            className="switch__checkbox"
            type="checkbox"
            id={props.id || props.name}
            name={props.name}
            defaultValue={props.value}
            onChange={props.handleChange}
            placeholder={props.placeholder}
            defaultChecked={props.checked}
            readOnly={props.readOnly}
            disabled={props.disabled}
            />
            <span className="switch__slider switch__slider--round"></span>
            <span className="switch__text">{props.title}</span>
        </label>
        </div>
    </div>
  );
};

export default Checkbox;
